import clsx from 'clsx'

import styles from './Loading.module.scss'
import Spinner from './Spinner'

type LoadingProps = {
  spinning?: boolean
  children: React.ReactNode
  className?: string
  innerClassName?: string
}

const Loading = (props: LoadingProps) => (
  <div className={clsx(styles.loading, props.className)}>
    {props.spinning ? <Spinner /> : null}
    <div
      className={clsx(
        props.spinning && styles.loadingBox,
        styles.loadingInner,
        props.innerClassName
      )}
    >
      {props.children}
    </div>
  </div>
)

export default Loading
